export const skillOptions = [
  {
    id: 1,
    skillName: "Acrobatics",
    skillAttr: "Dex",
    skillDesc: "You can keep your balance while traversing narrow or treacherous surfaces. You can also dive, flip, jump, and roll, avoiding attacks and confusing your opponents..",
  },
  {
    id: 2,
    skillName: "Appraise",
    skillAttr: "Int",
    skillDesc: "A DC 20 Appraise check determines the value of a common item. If you succeed by 5 or more, you also determine if the item has magic properties, although this success does not grant knowledge of the magic item’s abilities. If you fail the check by less ....",
  },
  {
    id: 3,
    skillName: "Bluff",
    skillAttr: "Chr",
    skillDesc: "Bluff is an opposed skill check against your opponent’s Sense Motive skill..",
  },
  {
    id: 4,
    skillName: "Climb",
    skillAttr: "Str",
    skillDesc: "With a successful Climb check, you can advance up, down, or across a slope, wall, or other steep incline (or even across a ceiling, provided it has handholds) at one-quarter your normal speed. A slope is considered to be any incline at an angle measuring....",
  },
  {
    id: 5,
    skillName: "Craft",
    skillAttr: "Int",
    skillDesc: "You are skilled in the creation of a specific group of items, such as armor or weapons. Like Knowledge, Perform, and Profession, Craft is actually a number of separate skills. You could have several Craft skills, each with its own ranks. The most common ....",
  },
  {
    id: 6,
    skillName: "Diplomacy",
    skillAttr: "Chr",
    skillDesc: "You can use this skill to persuade others to agree with your arguments, to resolve differences, and to gather valuable information or rumors from people. This skill is also used to negotiate conflicts by using the proper etiquette and manners suitable to....",
  },
  {
    id: 7,
    skillName: "Disable Device",
    skillAttr: "Dex",
    skillDesc: "You are skilled at disarming traps and opening locks. In addition, this skill lets you sabotage simple mechanical devices, such as catapults, wagon wheels, and doors..",
  },
  {
    id: 8,
    skillName: "Disguise",
    skillAttr: "Chr",
    skillDesc: "Your Disguise check result determines how good the disguise is, and it is opposed by others’ Perception check results. If you don’t draw any attention to yourself, others do not get to make Perception checks. If you come to the attention of people wh....",
  },
  {
    id: 9,
    skillName: "Escape Artist",
    skillAttr: "Dex",
    skillDesc: "Your training allows you to slip bonds and escape from grapples..",
  },
  {
    id: 10,
    skillName: "Fly",
    skillAttr: "Dex",
    skillDesc: "You are skilled at flying, either through the use of wings or magic, and you can perform daring or complex maneuvers while airborne. Note that this skill does not give you the ability to fly..",
  },
  {
    id: 11,
    skillName: "Handle Animal",
    skillAttr: "Chr",
    skillDesc: "You are trained at working with animals, and can teach them tricks, get them to follow your simple commands, or even domesticate them..",
  },
  {
    id: 12,
    skillName: "Heal",
    skillAttr: "Wis",
    skillDesc: "You are skilled at tending to the ailments of others..",
  },
  {
    id: 14,
    skillName: "Intimidate",
    skillAttr: "Chr",
    skillDesc: "You can use this skill to frighten an opponent or to get them to act in a way that benefits you. This skill includes verbal threats and displays of prowess..",
  },
  {
    id: 15,
    skillName: "Knowledge",
    skillAttr: "Int",
    skillDesc: "You are educated in a field of study and can answer both simple and complex questions. Like the Craft, Perform, and Profession skills, Knowledge actually encompasses a number of different specialties..",
  },{
    id: 36,
    skillName: "Knowledge (Engineering)",
    skillAttr: "Int",
    skillDesc: "You are educated in a field of study and can answer both simple and complex questions related to (buildings, aqueducts, bridges, fortifications); This is the most important skill with regard to technological subjects. Knowledge (engineering) can be used to identify a robot’s abilities and weaknesses. Knowledge (engineering) is also used to identify and understand unknown technological objects in a similar manner to how Spellcraft is used to identify the properties of a magic item. The DC to correctly identify and understand an unknown technological object is equal to the object’s Craft DC ",
  },
  {
    id: 37,
    skillName: "Knowledge (History)",
    skillAttr: "Int",
    skillDesc: "You are educated in a field of study and can answer both simple and complex questions related to (wars, colonies, migrations, founding of cities)",
  },
  {
    id: 38,
    skillName: "Knowledge (Local)",
    skillAttr: "Int",
    skillDesc: "You are educated in a field of study and can answer both simple and complex questions related to (legends, personalities, inhabitants, laws, customs, traditions, humanoids)",
  },
  {
    id: 39,
    skillName: "Knowledge (Nature)",
    skillAttr: "Int",
    skillDesc: "You are educated in a field of study and can answer both simple and complex questions related to (animals, fey, monstrous humanoids, plants, seasons and cycles, weather, vermin)",
  },
  {
    id: 40,
    skillName: "Knowledge (Nobility)",
    skillAttr: "Int",
    skillDesc: "You are educated in a field of study and can answer both simple and complex questions related to (lineages, heraldry, personalities, royalty)",
  },
  {
    id: 41,
    skillName: "Knowledge (Planes)",
    skillAttr: "Int",
    skillDesc: "You are educated in a field of study and can answer both simple and complex questions related to (the Inner Planes, the Outer Planes, the Astral Plane, the Ethereal Plane, outsiders, planar magic)",
  },
  {
    id: 42,
    skillName: "Knowledge (Religion)",
    skillAttr: "Int",
    skillDesc: "You are educated in a field of study and can answer both simple and complex questions related to (gods and goddesses, mythic history, ecclesiastic tradition, holy symbols, undead)",
  },
  {
    id: 43,
    skillName: "Knowledge (Dungeoneering)",
    skillAttr: "Int",
    skillDesc: "You are educated in a field of study and can answer both simple and complex questions related to (aberrations, caverns, oozes, spelunking)",
  },
  {
    id: 43,
    skillName: "Knowledge (Geography)",
    skillAttr: "Int",
    skillDesc: "You are educated in a field of study and can answer both simple and complex questions related to (lands, terrain, climate, people.) Used for astronomy.",
  },
  {
    id: 16,
    skillName: "Linguistics",
    skillAttr: "Int",
    skillDesc: "You are skilled at working with language, in both its spoken and written forms. You can speak multiple languages, and can decipher nearly any tongue given enough time. Your skill in writing allows you to create and detect forgeries as well..",
  },
  {
    id: 17,
    skillName: "Perception",
    skillAttr: "Wis",
    skillDesc: "Your senses allow you to notice fine details and alert you to danger. Perception covers all five senses, including sight, hearing, touch, taste, and smell..",
  },
  {
    id: 18,
    skillName: "Perform",
    skillAttr: "Chr",
    skillDesc: "You are skilled at one form of entertainment, from singing to acting to playing an instrument. Like Craft, Knowledge, and Profession, Perform is actually a number of separate skills. You could have several Perform skills, each with its own ranks..",
  },
  {
    id: 19,
    skillName: "Profession",
    skillAttr: "Wis",
    skillDesc: "You are skilled at a specific job. Like Craft, Knowledge, and Perform, Profession is actually a number of separate skills. You could have several Profession skills, each with its own ranks. While a Craft skill represents ability in creating an item, a Pr....",
  },
  {
    id: 20,
    skillName: "Ride",
    skillAttr: "Dex",
    skillDesc: "You are skilled at riding mounts, usually a horse, but possibly something more exotic, like a griffon or pegasus. If you attempt to ride a creature that is ill suited as a mount, you take a –5 penalty on your Ride checks..",
  },
  {
    id: 21,
    skillName: "Sense Motive",
    skillAttr: "Wis",
    skillDesc: "You are skilled at detecting falsehoods and true intentions..",
  },
  {
    id: 22,
    skillName: "Sleight of Hand",
    skillAttr: "Dex",
    skillDesc: "Your training allows you to pick pockets, draw hidden weapons, and take a variety of actions without being noticed..",
  },
  {
    id: 23,
    skillName: "Spellcraft",
    skillAttr: "Int",
    skillDesc: "You are skilled at the art of casting spells, identifying magic items, crafting magic items, and identifying spells as they are being cast..",
  },
  {
    id: 24,
    skillName: "Stealth",
    skillAttr: "Dex",
    skillDesc: "You are skilled at avoiding detection, allowing you to slip past foes or strike from an unseen position. This skill covers hiding and moving silently..",
  },
  {
    id: 25,
    skillName: "Survival",
    skillAttr: "Wis",
    skillDesc: "You are skilled at surviving in the wild and at navigating in the wilderness. You also excel at following trails and tracks left by others..",
  },
  {
    id: 26,
    skillName: "Swim",
    skillAttr: "Str",
    skillDesc: "You know how to swim and can do so even in stormy water..",
  },
  {
    id: 27,
    skillName: "Use Magic Device",
    skillAttr: "Chr",
    skillDesc: "You are skilled at activating magic items, even if you are not otherwise trained in their use..",
  },
  {
    id: 28,
    skillName: "Concentration",
    skillAttr: "Con & Modifier Stat",
    skillDesc: "You are skilled in casting spells while bing threatend. Each rank adds to the concentration check on defensive casting. Round Spell Stat Mod down",
  },



  
];
